import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { fieldfilter, capitalize } from '../../redux/actions/customFunction';
import { FormOutlined, EyeOutlined } from '@ant-design/icons';
import { Table, Row, Col, Breadcrumb, Typography, Tooltip, Tabs } from 'antd';
import { intialPaginationState, showingPageTotalRange, filter } from '../../common_functions';

const ListImgFields = props => {
  const [supportType, setSupportType] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [tabData, setTabData] = useState({
    activeTab: !!localStorage.getItem('TabActive') ? localStorage.getItem('TabActive') : 'Flora',
  });
  const [pagination, setPagination] = useState(intialPaginationState);
  const [sorter, setSorter] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fields, setFields] = useState([]);
  let filtersitems = {};

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        let { data: { meta: { options: { choices = [] } = {} } = {} } = {} } = await props.fetchFieldValues('support_table', {
          fields: ['type'],
        });
        let new_choices = [];
        choices.map(function (item, i) {
          item.value.includes('detail') && new_choices.push(item);
        });
        setSupportType(new_choices);
        //get fields from support table
        let { data: { meta: { options: { choices: choices_fields = [] } = {} } = {} } = {} } = await props.fetchFieldValues(
          'support_table',
          {
            fields: ['fields'],
          }
        );
        setFields(choices_fields);
        filtersitems = {};
        filtersitems['type'] = { _eq: tabData.activeTab.toLowerCase() };
        await getTableData(filtersitems, pagination);
      } catch (error) {
        console.log('error', error);
      } finally {
        setLoading(false);
      }
      localStorage.removeItem('TabActive');
    }
    fetchData();
  }, []);
  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'id',
      key: 'id',
      width: '10%',
      render: (value, item, index) => {
        return (pagination.current - 1) * pagination.pageSize + index + 1;
      },
    },
    {
      title: 'Field Name',
      dataIndex: 'fields',
      type: 'fields',
      width: '15%',
      render: text => {
        return <span>{fieldfilter(fields, text)}</span>;
      },
    },
    {
      title: 'Name',
      dataIndex: 'name',
      type: 'name',
      sorter: true,
      ...filter('name'),
    },
    {
      title: 'Code',
      dataIndex: 'code',
      type: 'code',
      sorter: true,
      ...filter('code'),
    },
    {
      title: 'Source',
      dataIndex: 'source',
      type: 'source',
      sorter: true,
      ...filter('code'),
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      sorter: true,
      ...filter('description'),
    },
    {
      title: 'Actions',
      key: 'action',
      render: (text, record) => (
        <span>
          <div className="actionbtngroup">
            <Link to={tabData && '/settings/image-description/' + tabData.activeTab.replaceAll(' ', '-').toLowerCase() + '/' + record.id}>
              <Tooltip
                placement="top"
                title={props.roleType === 'admin' || props?.tabs_permissions?.settings_image_description?.edit ? 'Edit' : 'View'}
              >
                <button className="edit-btn">
                  {props.roleType === 'admin' || props?.tabs_permissions?.settings_image_description?.edit ? (
                    <FormOutlined />
                  ) : (
                    <EyeOutlined />
                  )}
                </button>
              </Tooltip>
            </Link>
            {props.deleteRecord(
              props,
              record.id,
              'support_table',
              `${tabData.activeTab}?`,
              tableData,
              setTableData,
              props?.tabs_permissions?.settings_image_description?.delete
            )}
          </div>
        </span>
      ),
    },
  ];
  // get support table data
  const getTableData = async (condition, pagiNation, sorter = null) => {
    let respData = await props.getItems('support_table', {
      fields: ['*'],
      filters: condition,
      sort: !!sorter && sorter.field ? (sorter.order === 'ascend' ? '' : '-') + sorter.field : '-id',
      offset: pagiNation.pageSize * (pagiNation.current - 1),
      limit: pagiNation.pageSize,
      meta: 'filter_count',
    });
    setTableData(respData.data);
    pagiNation.total = respData.meta.filter_count;
    setPagination(pagiNation);
    respData && setLoading(false);
  };
  /***Handle tab active key**/
  const handleTabActiveKey = async e => {
    setLoading(true);
    filtersitems = {};
    setTabData({
      ...tabData,
      activeTab: e,
    });
    filtersitems['type'] = { _eq: e.toLowerCase() };
    try {
      await getTableData(filtersitems, intialPaginationState);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  let handleTableChange = async (pagination, filters, sorter) => {
    try {
      filtersitems = {};
      setLoading(true);
      setPagination(pagination);
      setSorter(sorter);
      for (var key in filters) {
        if (filters.hasOwnProperty(key)) {
          var val = filters[key];
          if (!!val) {
            filtersitems[key] = { _icontains: val[0] };
          }
        }
      }
      filtersitems['type'] = { _eq: tabData.activeTab.toLowerCase() };
      await getTableData(filtersitems, pagination, sorter);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Row>
      <Col span={24} className="app-breadcrumb-col">
        <Breadcrumb items={[{ title: "Settings", href: "/settings/image-description" }, { title: "Image Description" }]} />
      </Col>
      <Col className="white-paper" span={24}>
        <div className="dashboard">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                View Image Description
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end">
              {props.createButton(
                props.roleType,
                props.tabs_permissions.settings_image_description,
                tabData ? '/settings/image-description/' + tabData.activeTab.replaceAll(' ', '-').toLowerCase() + '/new' : '',
                `Add New ${capitalize(tabData.activeTab)}`
              )}
            </Col>
          </Row>
          <hr />
          {supportType && (
            <Tabs defaultActiveKey={tabData.activeTab.toLowerCase()} onChange={handleTabActiveKey} activeKey={tabData.activeTab.toLowerCase()} items={supportType.map((key, el) => {
  return {
    label: key.text,
    key: key.text.toLowerCase()
  };
})} />
          )}
          <div className="artist-listtableData">
            <Table
              scroll={{ x: 'max-content' }}
              columns={columns}
              bordered
              rowKey={record => record.id}
              dataSource={tableData}
              pagination={{ ...pagination, ...showingPageTotalRange }}
              loading={loading}
              onChange={handleTableChange}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default ListImgFields;
